export enum OverlayLayer {
  DRAWER = "DRAWER",
  MODAL = "MODAL",
}

export const OVERLAY_LAYER_PRIORITY: Record<OverlayLayer, number> = {
  DRAWER: 0,
  MODAL: 1,
};

// Stacked overlay z-index system
// Each overlay gets: base + (stackPosition * step)
// Backdrop sits at: topmostOverlay.zIndex - 1
export const OVERLAY_Z_INDEX_BASE = 9000;
export const OVERLAY_Z_INDEX_STEP = 10;

export const getOverlayZIndex = (stackPosition: number) => {
  return OVERLAY_Z_INDEX_BASE + stackPosition * OVERLAY_Z_INDEX_STEP;
};

// Toast z-index - always above dropdowns/tooltips (10000) but below SmallScreenWrapper
export const TOAST_Z_INDEX = 11000;

// Legacy flat z-index constants for Linaria static evaluation (fallback defaults)
export const DRAWER_Z_INDEX_OVERLAY = 8999;
export const DRAWER_Z_INDEX_BASE = 9000;
export const DRAWER_Z_INDEX_CONTENT = 9001;

export const MODAL_Z_INDEX_OVERLAY = 9099;
export const MODAL_Z_INDEX_BASE = 9100;
export const MODAL_Z_INDEX_CONTENT = 9100;

// Grouped object for runtime usage (not for Linaria styled components)
export const OVERLAY_Z_INDEX = {
  DRAWER: {
    overlay: DRAWER_Z_INDEX_OVERLAY,
    base: DRAWER_Z_INDEX_BASE,
    content: DRAWER_Z_INDEX_CONTENT,
  },
  MODAL: {
    overlay: MODAL_Z_INDEX_OVERLAY,
    base: MODAL_Z_INDEX_BASE,
    content: MODAL_Z_INDEX_CONTENT,
  },
} as const;
